import React from 'react';
import { connect, useDispatch } from 'react-redux';

import { track as trackEvent } from '../../actions';

type ResultType = (name: string, data?: any) => ReturnType<typeof trackEvent>;

export const useTrackEvent = (): ResultType => {
  const dispatch = useDispatch();

  return React.useCallback((...args) => dispatch(trackEvent(...args)), [
    dispatch,
  ]);
};

export const withTrackEvent = connect(null, {
  trackEvent,
});

export type withTrackEventProps = {
  trackEvent: ResultType;
};
